import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { ViewboxInterviewScheduleHttpClient } from './viewbox-interview-schedule-http-client';
import { ViewboxInterviewScheduleActions } from './viewbox-interview-schedule.store';

@Injectable({ providedIn: 'root' })
export class ViewboxInterviewScheduleEffects {
  public loadItem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewboxInterviewScheduleActions.loadItem),
      mergeMap(({ payload }) =>
        this.viewboxInterviewScheduleHttpClient
          .loadItem(
            payload.scheduleToken,
            payload.requestLinkToken,
            payload.candidateTimezone,
            payload.reschedule,
          )
          .pipe(
            switchMap(data => [ViewboxInterviewScheduleActions.loadItemSuccess({ payload: data })]),
            catchError(error =>
              of(ViewboxInterviewScheduleActions.loadItemFailed({ payload: error })),
            ),
          ),
      ),
    ),
  );

  public confirmSchedule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewboxInterviewScheduleActions.confirmSchedule),
      mergeMap(({ payload }) =>
        this.viewboxInterviewScheduleHttpClient.confirmSchedule(payload).pipe(
          switchMap(data => [
            ViewboxInterviewScheduleActions.confirmScheduleSuccess({ payload: data }),
          ]),
          catchError(({ error }) =>
            of(ViewboxInterviewScheduleActions.confirmScheduleFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );

  public rsvp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewboxInterviewScheduleActions.rsvp),
      mergeMap(({ payload }) =>
        this.viewboxInterviewScheduleHttpClient.rsvp(payload).pipe(
          switchMap(data => [ViewboxInterviewScheduleActions.rsvpSuccess({ payload: data })]),
          catchError(({ error }) =>
            of(ViewboxInterviewScheduleActions.rsvpFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );
  constructor(
    private actions$: Actions,
    private viewboxInterviewScheduleHttpClient: ViewboxInterviewScheduleHttpClient,
  ) {}
}
